import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Clock, Phone } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { toast } from 'sonner';
import NoticeBanner from '@/components/NoticeBanner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function PhoneAppointment({ user }) {
  const [formData, setFormData] = useState({ name: user?.name || '', email: user?.email || '', phone: user?.phone || '', date: '', time: '', message: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await fetch(`${BACKEND_URL}/api/appointments/phone`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });
      toast.success('Cita agendada. Te contactaremos pronto.');
      setFormData({ name: '', email: '', phone: '', date: '', time: '', message: '' });
    } catch (error) {
      toast.error('Error al agendar');
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <header className="sticky top-0 z-50 bg-white border-b border-gray-200">
        <div className="container mx-auto px-6 py-4">
          <Link to="/" className="text-2xl font-bold" style={{ fontFamily: 'Playfair Display' }}>ARTHUR FITZ</Link>
        </div>
      </header>

      {/* Notice Banner */}
      <NoticeBanner />

      <div className="container mx-auto px-6 py-12 max-w-6xl">
        <div className="mb-8">
          <h1 className="text-4xl font-bold mb-4" style={{ fontFamily: 'Playfair Display' }}>Agendar Cita Telefónica</h1>
          <p className="text-gray-600">Recibe asesoría personalizada de nuestros expertos</p>
        </div>

        <div className="grid md:grid-cols-2 gap-12">
          <div className="space-y-6">
            <div className="border border-gray-200 p-6">
              <h2 className="text-xl font-bold mb-6">Por qué Agendar</h2>
              <div className="space-y-4">
                <div className="flex gap-4">
                  <div className="bg-gray-100 rounded-full w-12 h-12 flex items-center justify-center flex-shrink-0">
                    <Calendar className="w-6 h-6" />
                  </div>
                  <div>
                    <h3 className="font-bold mb-1">Asesoría Personalizada</h3>
                    <p className="text-sm text-gray-600">Evaluamos tu caso y recomendamos la mejor solución</p>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="bg-gray-100 rounded-full w-12 h-12 flex items-center justify-center flex-shrink-0">
                    <Clock className="w-6 h-6" />
                  </div>
                  <div>
                    <h3 className="font-bold mb-1">Rápido y Cómodo</h3>
                    <p className="text-sm text-gray-600">Consulta telefónica desde donde estés</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="border-2 border-gray-900 p-6 bg-gray-50">
              <h3 className="font-bold text-lg mb-3">Contacto Directo</h3>
              <p className="text-gray-600 mb-4">¿Prefieres hablar ahora?</p>
              <Button onClick={() => window.open('https://wa.me/34649471889', '_blank')} className="w-full bg-black text-white hover:bg-gray-800">
                <Phone className="w-5 h-5 mr-2" />
                WHATSAPP: 649 471 889
              </Button>
            </div>
          </div>

          <div className="border border-gray-200 p-6">
            <h2 className="text-xl font-bold mb-6">Solicitar Cita</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div><Label>Nombre *</Label><Input value={formData.name} onChange={(e) => setFormData({...formData, name: e.target.value})} required className="border-gray-300" /></div>
              <div><Label>Email *</Label><Input type="email" value={formData.email} onChange={(e) => setFormData({...formData, email: e.target.value})} required className="border-gray-300" /></div>
              <div><Label>Teléfono *</Label><Input value={formData.phone} onChange={(e) => setFormData({...formData, phone: e.target.value})} required className="border-gray-300" /></div>
              <div className="grid grid-cols-2 gap-4">
                <div><Label>Fecha *</Label><Input type="date" value={formData.date} onChange={(e) => setFormData({...formData, date: e.target.value})} required min={new Date().toISOString().split('T')[0]} className="border-gray-300" /></div>
                <div><Label>Hora *</Label><Input type="time" value={formData.time} onChange={(e) => setFormData({...formData, time: e.target.value})} required className="border-gray-300" /></div>
              </div>
              <div><Label>Mensaje (Opcional)</Label><Textarea value={formData.message} onChange={(e) => setFormData({...formData, message: e.target.value})} rows={4} className="border-gray-300" /></div>
              <Button type="submit" className="w-full bg-black text-white hover:bg-gray-800 py-6 text-base font-medium">AGENDAR CITA</Button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
